import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { EcoEfficiencyDashboardContext } from "../../../contexts/EcoEfficiencyDashboardContext";
import { useTranslation } from "react-i18next";
import { common } from "../../../i18n";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { ComponentPredicted } from "./widgets/component-predicted/ComponentPredicted";
import EcoEfficiencyPerformanceOverTime from "./widgets/performance/EcoEfficiencyPerformanceOverTime";
import { EcoEfficiencyBySubOrganization } from "./widgets/sub-organization";
import { EcoEfficiencyByComponent } from "./widgets/eco-efficiency-by-component/EcoEfficiencyByComponent";
import EcoYoyChart from "./widgets/economicYoY/EcoYoyChart";

const EcoEfficiencyDashboardContent = () => {
  const { t } = useTranslation([common], {
    nsMode: "fallback",
  });
  const { selectedEcoEfficiency, ecoEfficiencyDashboardFilterForm } =
    EcoEfficiencyDashboardContext();

  const organizationType =
    ecoEfficiencyDashboardFilterForm.watch("organizationType");
  return (
    <>
      {/* case selectedEcoEfficiency - Show table + Charts */}
      {selectedEcoEfficiency && (
        <>
          <Box
            display={"flex"}
            alignSelf={"stretch"}
            bgcolor={"var(--gray3)"}
            m={"0px 40px"}
            p={"8px 12px"}
            gap={"8px"}
            borderRadius={"8px"}
          >
            <InfoOutlinedIcon color="primary" />
            <Typography color={"primary"} variant={"text2"}>
              {t("Eco-Efficiency-Dashboard-Note-Year", {
                param1: `${selectedEcoEfficiency.year}`,
                param2: `${selectedEcoEfficiency.baseYear}`,
              })}
            </Typography>
          </Box>

          <Grid2
            container
            disableEqualOverflow
            gap={"24px"}
            marginX={"40px"}
            marginBottom={"12px"}
            color={"var(--dark)"}
            marginTop={"24px"}
          >
            <Grid2 xs={12}>
              <EcoEfficiencyPerformanceOverTime />
            </Grid2>

            {organizationType === "sub-organization" && (
              <Grid2 xs={12}>
                <EcoEfficiencyBySubOrganization />
              </Grid2>
            )}

            <Grid2 xs={12}>
              <EcoEfficiencyByComponent />
            </Grid2>

            <Grid2 xs={12}>
              <ComponentPredicted />
            </Grid2>

            <Grid2 xs={12} md>
              <EcoYoyChart />
            </Grid2>
          </Grid2>
        </>
      )}
    </>
  );
};

export default EcoEfficiencyDashboardContent;
